module.exports = __webpack_public_path__ + "img/swap-up.34d81086.svg";